import { createBlobInContainer } from './azureBlob';

export const uploadImageAndGetUrl = async (file) => {
    if (!file) return null;
    const safeName = file.name.replace(/\s+/g, '_');
    const uniqueName = `${Date.now()}_${safeName}`;
    const renamedFile = new File([file], uniqueName, { type: file.type });
    await createBlobInContainer(renamedFile);
    const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
    const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
    return `https://${storageAccountName}.blob.core.windows.net/${containerName}/${uniqueName}`;
};


